module.exports = __webpack_public_path__ + "static/media/slider_2_collab_user_en.bf9397e5.svg";